var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-domain-banner"},[_c('div',{staticClass:"banner-img",staticStyle:{"cursor":"pointer"},on:{"click":_vm.new_link}},[_c('div',{staticClass:"link-switch auto fix"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/header.vue